import { Column } from "@/components/Column";
import { Text } from "@/components/Text";
import { SadieStatDelta } from "@/components/tools/sadie-dashboard/SadieStatDelta";
import { Card } from "@ui/card";

import {
  SadieDashboardRange,
  SadieDashboardStat,
  SadieStatFormat,
} from "@/types";

// Sadie's new reach: workers she texted for the first time in the window.
export const SadieWorkersTextedCard = ({
  range,
  workersFirstTexted,
}: {
  range: SadieDashboardRange;
  workersFirstTexted: SadieDashboardStat;
}) => (
  <Card className="p-5">
    <Column className="gap-3">
      <Column className="gap-0.5">
        <Text className="font-plex-mono text-[9px] font-medium uppercase tracking-wider text-slate-500">
          Reach
        </Text>
        <Text className="text-sm font-semibold text-slate-900">
          Workers texted
        </Text>
      </Column>
      <Text className="text-3xl font-semibold text-slate-900">
        {workersFirstTexted.value.toLocaleString()}
      </Text>
      <SadieStatDelta
        format={SadieStatFormat.COUNT}
        range={range}
        stat={workersFirstTexted}
      />
      <Text className="text-xs font-normal text-slate-500">
        Texted by Sadie for the first time, including any who later opted out
      </Text>
    </Column>
  </Card>
);
